import axios from "axios";
import { z } from "zod";
import { TrainingRegistrationSchema } from "../../fixtures/training-registration-schema";
import { formatDate, todayDate } from "../../fixtures/formatting";
import { TrainingRegistrationInstallmentSchema } from "../../fixtures/training-registration-installment-schema";

export const BASE_URL = process.env.REACT_APP_API_URL;

export const UploadFile = async (file: any) => {
  if (!file) return;

  try {
    const { data } = await axios.get(
      `${BASE_URL}/getuploadurl?file=${file.name}`
    );

    await axios.put(data.data.url, file);

    return data.data.Key;
  } catch (error) {
    console.error(error, "Failed to upload Agreement!");
  }
};

export const registerForTraining = async (
  values: z.infer<typeof TrainingRegistrationSchema>
) => {
  const payload = {
    full_name: values.full_name,
    email: values.email,
    phone_no: values.phone_number,
    whatsapp_no: values.whatsapp_number,
    date_of_birth: formatDate(values.date_of_birth),
    gender: values.gender,
    address: {
      building_name: values.building_name,
      landmark: values.landmark,
      city: values.city,
      district: values.district,
      State: values.state,
      pin: values.postal_code,
    },
    training_program: values.training_program,
    preferred_time: values.preferred_time,
    date: todayDate(),
  };

  const response = await axios.post(
    `${BASE_URL}/training-registration`,
    payload
  );

  return response.data;
};

export const registerForTrainingInstallment = async (
  values: z.infer<typeof TrainingRegistrationInstallmentSchema>
) => {
  const signatureKey = await UploadFile(values.signature);
  const agreementKey = await UploadFile(values.agreement);

  if (signatureKey && agreementKey) {
    const payload = {
      full_name: values.full_name,
      email: values.email,
      phone_no: values.phone_number,
      date_of_birth: formatDate(values.date_of_birth),
      gender: values.gender,
      address: {
        building_name: values.building_name,
        landmark: values.landmark,
        city: values.city,
        district: values.district,
        State: values.state,
        pin: values.postal_code,
      },
      training_program: values.training_program,
      preferred_time: values.preferred_time,
      signature: signatureKey,
      agreement: agreementKey,
      date: todayDate(),
    };

    const response = await axios.post(`${BASE_URL}/form-extended`, payload);

    return response.data;
  } else {
    throw new Error("Failed to Submit Form!");
  }
};
